export const accessMap = [
    {
        key: "Full access",
        text: "Full access",
        entity: {
            create: true,
            read: true,
            update: true,
            delete: true,
            accessLists: true,
			manageLists: true,
            accessCharts: true,
            manageCharts: true
        },
        attribute: "Edit"
    },
    {
        key: "Read only",
        text: "Read only",
        entity: {
            create: false,
            read: true,
            update: false,
            delete: false,
            accessLists: true,
			manageLists: false,
            accessCharts: true,
            manageCharts: false
        },
        attribute: "Readonly"
    },
    {
        key: "No access",
        text: "No access",
        entity: {
            create: false,
            read: false,
            update: false,
            delete: false,
            accessLists: false,
            manageLists: false,
            accessCharts: false,
            manageCharts: false
        },
        attribute: "Hidden"
    }
]